
import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Maria Silva',
      role: 'Contadora - CRC/SP ***457',
      company: 'Silva & Associados Contabilidade',
      image: 'https://static.readdy.ai/image/32a46051d4b6ab62d557a533e4dd9650/a0a042f6b6a4b31f2ef8e253723a2191.jpeg',
      text: 'O curso superou minhas expectativas! O conteúdo é extremamente atual e os professores dominam completamente o assunto. Consegui aplicar os conhecimentos imediatamente no meu escritório.',
      rating: 5
    },
    {
      name: 'Carlos Mendes',
      role: 'Analista Fiscal Sênior',
      company: 'Grupo Empresarial',
      image: 'https://static.readdy.ai/image/32a46051d4b6ab62d557a533e4dd9650/01dd326223d3db3e8e0b5c192a5bad9c.jpeg',
      text: 'Excelente didática e casos práticos muito relevantes. O networking foi um bônus incrível - conheci profissionais que se tornaram parceiros de negócio.',
      rating: 5
    },
    {
      name: 'Ana Rodrigues',
      role: 'Gestora Tributária',
      company: '.',
      image: 'https://static.readdy.ai/image/32a46051d4b6ab62d557a533e4dd9650/17e3fa39dc223d1fa88aede6d49db547.jpeg',
      text: 'Investimento que se paga rapidamente! As estratégias apresentadas me ajudaram a otimizar a carga tributária da empresa em mais de 15%.',
      rating: 5
    }
  ];

  const stats = [
    { number: '2.000+', label: 'Profissionais Capacitados' },
    { number: '98%', label: 'Satisfação' },
    { number: '15+', label: 'Anos de Experiência' },
    { number: '50+', label: 'Produtos em soluções Tributária ' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            O que nossos alunos dizem
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Depoimentos reais de profissionais que transformaram suas carreiras 
            com nossos cursos especializados
          </p>
        </div>

        {/* Estatísticas */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-blue-800 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Depoimentos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-600">
                    {testimonial.role}
                  </p>
                  <p className="text-xs text-gray-500">
                    {testimonial.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-800 to-blue-900 rounded-xl p-8 text-white">
            <h3 className="text-3xl font-bold mb-4">
              O caminho está definido. A única variável agora é: você vai conosco?
            </h3>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Não perca a oportunidade de se destacar no mercado com conhecimento 
              atualizado sobre a reforma tributária
            </p>
            <button
              onClick={() => document.getElementById('inscricao')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-up-line mr-2"></i>
              "Validar o passaporte para o evento" ✅
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
